"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popupTimePickerPropTypes = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _propTypes = require("../popup-date-picker/propTypes");

var _propTypes2 = require("../propTypes");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var timePickerSelectedValue = {
  hours: _stencilReactDesc.PropTypes.number,
  minutes: _stencilReactDesc.PropTypes.number
};
var popupTimePickerPropTypes = {
  selectedTime: _stencilReactDesc.PropTypes.shape(timePickerSelectedValue).description('Value of the time picker.'),
  onChange: _stencilReactDesc.PropTypes.func.description('Called when a new time is selected.'),
  shouldDisplay24Hours: _stencilReactDesc.PropTypes.bool.description('Whether the component should display 12-hour or 24-hour time. The value passed through onChange will always be in 24-hour format.'),
  labelText: _stencilReactDesc.PropTypes.string.description('Text for the component label.'),
  renderLabel: _stencilReactDesc.PropTypes.func.description('Customizes how the labelText is displayed.'),
  clearButtonAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the clear button.'),
  timePickerButtonAltText: _stencilReactDesc.PropTypes.string.description('Alt text for the clock button that opens a popover.'),
  invalidValueErrorText: _stencilReactDesc.PropTypes.string.description('Error text that is displayed in the component footer when the value is invalid.'),
  inputProps: _stencilReactDesc.PropTypes.object.description('Props that will be passed to the input inside the component, e.g. error or disabled.'),
  popoverProps: _propTypes.basePopupDatePickerPropTypes.popoverProps,
  ariaLabels: _stencilReactDesc.PropTypes.shape(_objectSpread(_objectSpread({}, _propTypes2.timePickerAriaLabels), {}, {
    increase: _propTypes2.timePickerAriaLabels,
    decrease: _propTypes2.timePickerAriaLabels
  })).description('Sets the aria labels for each segment of the time picker popup.')
};
exports.popupTimePickerPropTypes = popupTimePickerPropTypes;